export function formatServerErrors(errors: { response?: { data: { errors: string[] }; status?: number } }) {
    if (errors?.response?.status === 422) {
        const temp = {};
        for (let index = 0; index < errors.response.data.errors.length; index++) {
            const element = errors.response.data.errors[index];
            temp[element[0]] = element[1][0];
        }
        return temp;
    }

    return [];
}

export function formatAuthErrors(errors: { response?: { data: { errors: string[] }; status?: number } }) {
    if (errors?.response?.status === 400) {
        return { errors: { password: 'Sorry the credentials you are using are invalid' }, status: true };
    }

    return { errors, status: false };
}
